import type { PillMarkProps } from "./types-gantt";
import { useGanttPillMark } from "./use-gantt-pill-mark";
import { PillMarkView } from "./view-gantt-pill-mark";

/** Pill de duração dentro da faixa: centralizado, ou colado à borda quando a faixa encosta nela. */
export function PillMark(props: PillMarkProps) {
  const viewModel = useGanttPillMark(props);

  return <PillMarkView {...viewModel} />;
}
PillMark.displayName = "PillMark";
